
























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mixin as clickaway } from 'vue-clickaway';
import HtmlFormatter from '@/shared/services/htmlFormatter';

@Component({ mixins: [clickaway] })
export default class EditableText extends Vue {
	@Prop() public value: string;
	@Prop() public placeholder: string;
	@Prop({default: false}) public multiline: boolean;
	@Prop({default: false}) public allowEmpty: boolean;
	@Prop() public maxWidth: string;
	@Prop() public minWidth: string;
	@Prop({default: 100}) public maxChars: number;

	public $refs: {
		textfield: any,
	};

	public text: string = '';
	public isEditing: boolean = false;

	@Watch('value', { immediate: true })
	public onValueChanged(value: string, previous: string) {
		this.text = value;
	}

	public hasText() {
		return this.text && this.text.length > 0;
	}

	public getPlaceholder() {
		return this.placeholder ? this.placeholder : '&nbsp;';
	}

	public startEditing() {
		this.isEditing = true;
		this.$nextTick(() => {
			let el = this.$refs.textfield;
			if (this.multiline) {
				el = this.$refs.textfield.$el;
			}
			HtmlFormatter.setCaretAtTheEndOfContentEditable(el);
		});
	}

	public finishEditing() {
		this.isEditing = false;
		const previousValue = this.value;
		if (!this.allowEmpty && this.textEmpty()) {
			this.text = this.value;
			this.$emit('text-updated', this.text, previousValue);
		} else {
			this.$emit('text-updated', this.text, previousValue);
		}
	}

	public onInput(e: any) {
		const userInput = e.target.innerText;
		if (userInput.length < this.maxChars) {
			this.text = userInput;
		}
	}

	private textEmpty(): boolean {
		return (typeof this.text === 'undefined' || !this.text || 0 === this.text.length);
	}
}
